import React from "react";
import PropTypes from "prop-types";

const PromoSingleSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading } = section;

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      <div className="wrapper--inner flex flex-w-w flex-jc-sb">
        <div className={`ta-left col-1 col-md-1 col-lg-1 bg-${colour} cta-block promo-single flex-md ta-left`}>
          <a href={content.url}>
            <img alt={content.image_alt} src={content.image} srcSet={content.image_srcset} className="ie-resize" />
          </a>
          <div className="cta-block-copy">
            {heading && <h3 className={`ff-s h2 color-${colour}`} dangerouslySetInnerHTML={{__html: heading}}></h3>}
            <div dangerouslySetInnerHTML={{__html: content.content}}></div>
            <a href={content.url} className={`btn-m-m btn-${colour}`}>{content.button}</a>
          </div>
        </div>
      </div>
    </div>
  );
}


PromoSingleSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default PromoSingleSection;
